// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__362Jx","author":"Table_author__1AsmG","authorImage":"Table_authorImage__3GJvY","unreadRow":"Table_unreadRow__2FhOR"};